
        import { createApi } from '@reduxjs/toolkit/query/react';
        import { createBaseQuery } from 'src/datahandling/redux/api/apiUtils';

        // Initialize an empty API service that we'll inject endpoints into later as needed
        export const knowledgerApi = createApi({
        reducerPath: 'knowledgerAutoGeneratedApi',
        baseQuery: createBaseQuery("KNOWLEDGER_API"),
        
        endpoints: () => ({}),
        });

        export type knowledgerApiType = typeof knowledgerApi;
        export default knowledgerApi;
    